import { ZUid } from "src/types/zUid";
import { allBusinessServices } from "./allBusinessServices";
import { loadServicesForObject } from "./apiBusinessServices";
import { BusinessFunctionDescriptor } from "./BusinessServiseDescriptor";
import { ObjectServiceExt } from "./businessServises.types";

export type BsFuncDef = BusinessFunctionDescriptor & {
  info: ObjectServiceExt;
};

export const availableFunctions = async (
  objectId: ZUid,
): Promise<BsFuncDef[]> => {
  // Здесь переводить не надо. Потому что нужно получить имя функции для поиска в списке allBusinessServices
  // А так как все функции в любом случае реализованы на фронте, то и переводы словаре фронта.
  const servList = await loadServicesForObject(objectId, { translate: true });
  const result: BsFuncDef[] = [];

  allBusinessServices.forEach(({ key, functions }) => {
    const info = servList.find(({ serviceKey }) => serviceKey === key);
    if (info?.functions) {
      functions?.forEach(({ functionName, menuItem }) => {
        const func = info.functions?.find(
          (fn) => fn.functionName === functionName,
        );
        if (func?.active) {
          result.push({
            functionName: func.displayFunctionName ?? functionName,
            menuItem,
            info,
          });
        }
      });
    }
  });
  return result;
};
